import { format, isValid, parseISO } from 'date-fns';

const LOCAL_DATE_FORMAT = 'yyyy-MM-dd';
const LOCAL_DATE_TIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";

/**
 * Audit date answers are static wall-clock values, not points in time.
 * They must not contain a timezone or be converted to UTC when serialised.
 */
export function formatLocalDateAnswer(value: Date, includeTime: boolean): string {
  if (!isValid(value)) {
    return '';
  }

  return format(value, includeTime ? LOCAL_DATE_TIME_FORMAT : LOCAL_DATE_FORMAT);
}

/**
 * Parses new timezone-free audit answers as local values while remaining
 * compatible with existing ISO answers and older human-readable results.
 */
export function parseLocalDateAnswer(value: Date | string | null | undefined): Date | null {
  if (value instanceof Date) {
    return isValid(value) ? new Date(value.getTime()) : null;
  }

  if (typeof value !== 'string' || value.trim().length === 0) {
    return null;
  }

  const input = value.trim();
  const isoDate = parseISO(input);
  if (isValid(isoDate)) {
    return isoDate;
  }

  const legacyDate = new Date(input);
  return isValid(legacyDate) ? legacyDate : null;
}
export function formatLocalDateAnswerDisplay(value: Date | string | null | undefined, includeTime: boolean): string {
  const parsed = parseLocalDateAnswer(value);
  if (!parsed) {
    return '';
  }

  return format(parsed, includeTime ? 'dd MMM yyyy HH:mm' : 'dd MMM yyyy');
}
